import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const DeltaBadge = ({ delta }) => {
  if (delta == null || isNaN(delta)) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        color: '#8c8c8c', backgroundColor: '#fafafa', border: '1px solid #e8e8e8',
        borderRadius: 6, fontSize: 12, fontWeight: 700,
        padding: '2px 10px',
      }}>
        —
      </span>
    );
  }

  const val = parseFloat(delta);
  if (val === 0) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        color: '#8c8c8c', backgroundColor: '#fafafa', border: '1px solid #e8e8e8',
        borderRadius: 6, fontSize: 12, fontWeight: 700,
        padding: '2px 10px',
      }}>
        0.0
      </span>
    );
  }

  const isPositive = val > 0;
  const color = isPositive ? '#389e0d' : '#cf1322';
  const bg = isPositive ? '#f6ffed' : '#fff1f0';
  const border = isPositive ? '#b7eb8f' : '#ffa39e';
  const icon = isPositive
    ? <ArrowUpOutlined style={{ fontSize: 10 }} />
    : <ArrowDownOutlined style={{ fontSize: 10 }} />;
  const text = isPositive ? `+${val.toFixed(1)}` : val.toFixed(1);

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      color, backgroundColor: bg, border: `1px solid ${border}`,
      borderRadius: 6, fontSize: 12, fontWeight: 700,
      padding: '2px 10px',
    }}>
      {icon}
      <span>{text}</span>
    </span>
  );
};

export default DeltaBadge;
